module.exports = __webpack_public_path__ + "media/images/navbar/dropdown_menu/explore-6a1403961b450cb4fc12ebd4b380c4cb.svg";